import { render, staticRenderFns } from "./subOrder.vue?vue&type=template&id=58b05dcd"
import script from "./subOrder.vue?vue&type=script&lang=js"
export * from "./subOrder.vue?vue&type=script&lang=js"
import style0 from "./subOrder.vue?vue&type=style&index=0&id=58b05dcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports